/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_1_DpoInputs */

const en_privacy_section_1_dpo = /** @type {(inputs: Privacy_Section_1_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data protection officer has been appointed, as the criteria in Article 37(1) of the GDPR are not met.`)
};

const lv_privacy_section_1_dpo = /** @type {(inputs: Privacy_Section_1_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datu aizsardzības speciālists nav iecelts, jo neizpildās Vispārīgās datu aizsardzības regulas 37. panta 1. punktā noteiktie kritēriji.`)
};

/**
* | output |
* | --- |
* | "No data protection officer has been appointed, as the criteria in Article 37(1) of the GDPR are not met." |
*
* @param {Privacy_Section_1_DpoInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_1_dpo = /** @type {((inputs?: Privacy_Section_1_DpoInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_1_DpoInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_1_dpo(inputs)
	return en_privacy_section_1_dpo(inputs)
});